// extracted by mini-css-extract-plugin
module.exports = {"CommentDate":"PostDetailComments_CommentDate__9L_3U"};